// ----------------------------------------------------------------------

import { useTheme } from "@mui/material";

export default function Card(theme) {
  const { palette } = useTheme();

  const isDark = palette.mode === "dark";

  return {
    MuiCard: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          position: "relative",
          border: isDark ? "0.3px solid #003B64" : "0.3px solid #CCD9E2",
          // boxShadow: theme.customShadows.card,
          borderRadius: "8px",
          borderRadius: Number(theme.shape.borderRadius) * 2,
          zIndex: 0, // Fix Safari overflow: hidden with border radius
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: "h6" },
        subheaderTypographyProps: {
          variant: "body2",
          marginTop: theme.spacing(0.5),
        },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
  };
}
